import L from "leaflet";
import { Marker } from "react-leaflet";
import { Vegsperring } from "../../../services/RuteplanAPI";
import vegsperringIconResource from "../../../assets/roadblock_icon.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const vegsperringIcon = L.icon({
    iconUrl: vegsperringIconResource,
    iconRetinaUrl: vegsperringIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IVegsperringMarkersProps {
    vegsperringer: Array<Vegsperring>;
}

export default function VegsperringMarkers (props: IVegsperringMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { vegsperringer } = props;

    return (
        <>
            {vegsperringer.map((vegsperring: Vegsperring, index: number) => {
                return (
                    <Marker key={vegsperring.function + index} 
                    position={[vegsperring.location!.y, vegsperring.location!.x]} 
                    icon={vegsperringIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(vegsperring);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}